import { useContext } from 'react';

import { BuyTicketsLayoutContext } from '../layouts/BuyTicketsLayout';

export const useScrollToTimeSlot = () => {
  const { setIsTimeSlotsAnimating } = useContext(BuyTicketsLayoutContext);

  const scrollToSlot = (timeSlotEl: HTMLButtonElement, middle = false) => {
    const parentEl = timeSlotEl.parentElement;

    if (parentEl && timeSlotEl) {
      setIsTimeSlotsAnimating(true);

      parentEl.scrollTo({
        top: timeSlotEl.offsetTop - (middle ? parentEl.clientHeight / 2 : 0),
        behavior: 'smooth',
      });

      setTimeout(() => {
        let scrollTop = parentEl.scrollTop;
        let matchingFrameCount = 0;

        requestAnimationFrame(function checkScrollPosition() {
          const scrollTop_ = parentEl.scrollTop;

          if (scrollTop === scrollTop_) {
            matchingFrameCount++;

            if (matchingFrameCount > 2) {
              setIsTimeSlotsAnimating(false);

              return;
            }
          } else {
            scrollTop = scrollTop_;
            matchingFrameCount = 0;
          }

          requestAnimationFrame(checkScrollPosition);
        });
      });
    }
  };

  return { scrollToSlot };
};
